import React from 'react';
import { SF_SYMBOLS } from '@/assets/icons/sf-symbols';
import { ICON_ALIASES } from '@/constants/iconAliases';

/**
 * Renders an SF Symbol icon by semantic alias name.
 *
 * Usage:
 *   <SFIcon name="add" />
 *   <SFIcon name="close" size={16} color="#FC665C" />
 *   <SFIcon name="deviceIphone" size={24} className="my-icon" />
 *
 * Props:
 *   name     – semantic alias from ICON_ALIASES (or raw SF Symbol name as fallback)
 *   size     – width & height in px (default: 20)
 *   color    – CSS color string (default: "currentColor" — inherits from parent)
 *   className, style – passed through for layout
 */
const SFIcon = ({ name, size = 20, color = 'currentColor', className, style }) => {
  const sfName = ICON_ALIASES[name] ?? name;
  const IconComponent = SF_SYMBOLS[sfName];

  if (!IconComponent) return null;

  return (
    <IconComponent
      width={size}
      height={size}
      style={{ color, flexShrink: 0, display: 'inline-block', ...style }}
      className={className}
    />
  );
};

export default SFIcon;
